import { Component } from '@angular/core';

@Component({
  selector: 'app-home-welcome-guest',
  templateUrl: './welcome-guest.component.html',
  styleUrls: ['./welcome-guest.component.scss'],
})
export class HomeWelcomeGuestComponent {}
